import { render, staticRenderFns } from "./SetariUsers.vue?vue&type=template&id=ddfbc8d0&scoped=true"
import script from "./SetariUsers.vue?vue&type=script&lang=js"
export * from "./SetariUsers.vue?vue&type=script&lang=js"
import style0 from "./SetariUsers.vue?vue&type=style&index=0&id=ddfbc8d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfbc8d0",
  null
  
)

export default component.exports